import { BarrierOpenModeEnum } from '@zaoblako/shared/modules/cctv/enums/barrier-open-mode.enum';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link BarrierOpenModeEnum} enumeration values */
export const BarrierOpenModeEnumI18n: EnumI18nInterface<BarrierOpenModeEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [BarrierOpenModeEnum.NET_PING_DEVICE]: 'Открывать через "NetPing"',
    [BarrierOpenModeEnum.CONVERTER]: 'Открывать через "IronLogic"',
    [BarrierOpenModeEnum.ISAPI]: 'Открывать через API камеры',
  },
  [I18nLocalesEnum.EN_US]: {
    [BarrierOpenModeEnum.NET_PING_DEVICE]: 'Open by "NetPing" device',
    [BarrierOpenModeEnum.CONVERTER]: 'Open by "IronLogic" converter',
    [BarrierOpenModeEnum.ISAPI]: 'Open by "Hikvision" camera API ("ISAPI")',
  },
};
